import React from "react"
import { useSelector } from 'react-redux';
import { saveAs } from 'file-saver';
import ExcelJS from 'exceljs';
import styles from "./index.module.scss"
import { ExportIcon } from "../../../../../components/icons/export"
import SecondaryButton from "../../../../../components/ui/secondary-button"

const ExportFileTab = () => {
    const { auth, bins, markers } = useSelector(state => state.user)
  
    const exportBins = async () => {
      const binsData = bins.map(bin => ({
        name: bin.name,
        address: bin.address,
        fill_level: bin.fill_level,
        zone: bin.zone
      }));
    
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Bins');
    
      // Define the header style
      const headerStyle = {
        font: { bold: true, color: { argb: '000000' }, size: 14 },
        alignment: { horizontal: 'center', vertical: 'middle' },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF' } } // Green background
      };
    
      // Add the headers
      worksheet.columns = [
        { header: 'Name', key: 'name', width: 10, style: headerStyle },
        { header: 'Address', key: 'address', width: 60, style: headerStyle },
        { header: 'Fill Level', key: 'fill_level', width: 10, style: headerStyle },
        { header: 'Zone', key: 'zone', width: 10, style: headerStyle }
      ];
    
      // Add the data with alternating row colors
      binsData.forEach((bin, index) => {
        const row = worksheet.addRow(bin);
        row.eachCell((cell, colNumber) => {
          if (cell.value !== null) { // Only apply fill to cells with data
            cell.style = {
              alignment: { horizontal: 'center', vertical: 'middle' },
              fill: {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: index % 2 === 0 ? '77a689' : 'a9c9b5' } // Alternating light and dark green
              }
            };
          }
        });
      });
    
      // Write the Excel file
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, 'bins.xlsx');
    };
  
    return (
        
      <div>
        <main className={styles.main} onClick={exportBins}>
        <ExportIcon className={styles.icon} />
        <div className={styles.title}>Export File</div>
        </main>
      </div>
    );
  };
  
  export default ExportFileTab;
